import { createColumn, defaultColumns, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Company',
    field: 'companyId',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'companyId',
      fk: 'companyId',
      namespace: 'company',
      filterIs: 'text-filter'
    })
  }),
  createColumn({
    label: 'Work Type',
    field: 'workTypeId',
    ...relationField({
      props: {
        config: {
          params: {}
        }
      },
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'workTypeId',
      fk: 'workTypeId',
      namespace: 'workType',
      filterIs: 'text-filter'
    })
  })
].concat(defaultColumns)
